/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../ledger/ledger';
import '../../../common/currency';
import '../../../common/time';
import '../../../paymentbalances/external_sources';
import '../../../ledger/detail';
import '../models/users';
import '../../../deposits/model';
import '../../../bills/tender';
import '../../../feeplans/service';
import './request';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "SettlementType": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "ZERO_AMOUNT_SETTLEMENT": 1,
                          "STANDARD": 2,
                          "SCHEDULED_INSTANT": 3,
                          "MANUAL_INSTANT": 4,
                          "DEBIT_CARD_PAY_IN": 5,
                          "PAYROLL_TRANSFER": 6,
                          "CAPITAL_TRANSFER": 7,
                          "DIRECT_DEPOSIT": 8,
                          "DIRECT_DEPOSIT_IN": 9,
                          "DIRECT_DEPOSIT_OUT": 10,
                          "BALANCE_TRANSFER": 11,
                          "BALANCE_TRANSFER_IN": 12,
                          "BALANCE_TRANSFER_OUT": 13
                        }
                      },
                      "SettlementEntry": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "paymentToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "entryType": {
                            "type": ".squareup.ledger.LedgerEntry.Type",
                            "id": 3,
                            "rule": "optional"
                          },
                          "toUserMoney": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "toFeeAccountMoney": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "collectedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 7,
                            "rule": "optional"
                          },
                          "paymentCreatedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 8,
                            "rule": "optional"
                          },
                          "eventType": {
                            "type": ".squareup.paymentbalances.ExternalSource.Name",
                            "id": 9,
                            "rule": "optional"
                          },
                          "eventId": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "requestCreatedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 11,
                            "rule": "optional"
                          },
                          "billToken": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "ledgerEntryDetail": {
                            "type": ".squareup.ledger.LedgerEntryDetail",
                            "id": 13,
                            "rule": "optional"
                          }
                        }
                      },
                      "SettlementReport": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "paymentCount": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "bankAccountToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "settlementMoney": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "salesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "taxMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "tipMoney": {
                            "type": ".squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "refundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "totalFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 9,
                            "rule": "optional"
                          },
                          "netSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 10,
                            "rule": "optional"
                          },
                          "totalHeldMoney": {
                            "type": ".squareup.common.Money",
                            "id": 11,
                            "rule": "optional"
                          },
                          "totalReleasedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 13,
                            "rule": "optional"
                          },
                          "settlementEntries": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementEntry",
                            "id": 14,
                            "rule": "repeated"
                          },
                          "discountMoney": {
                            "type": ".squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "grossSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 16,
                            "rule": "optional"
                          },
                          "netTotalMoney": {
                            "type": ".squareup.common.Money",
                            "id": 17,
                            "rule": "optional"
                          },
                          "freeProcessingMoney": {
                            "type": ".squareup.common.Money",
                            "id": 18,
                            "rule": "optional"
                          },
                          "uncategorizedAdjustmentsMoney": {
                            "type": ".squareup.common.Money",
                            "id": 19,
                            "rule": "optional"
                          },
                          "subscriptionFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 20,
                            "rule": "optional"
                          },
                          "success": {
                            "type": "bool",
                            "id": 21,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "beginTime": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 22,
                            "rule": "optional"
                          },
                          "endTime": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 23,
                            "rule": "optional"
                          },
                          "totalCollectedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 24,
                            "rule": "optional"
                          },
                          "billCount": {
                            "type": "int64",
                            "id": 25,
                            "rule": "optional"
                          },
                          "surchargeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 26,
                            "rule": "optional"
                          },
                          "capitalAdvanceMoney": {
                            "type": ".squareup.common.Money",
                            "id": 27,
                            "rule": "optional"
                          },
                          "capitalRepaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 28,
                            "rule": "optional"
                          },
                          "totalCreditMoney": {
                            "type": ".squareup.common.Money",
                            "id": 29,
                            "rule": "optional"
                          },
                          "totalBankPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 59,
                            "rule": "optional"
                          },
                          "totalCashAppPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 61,
                            "rule": "optional"
                          },
                          "totalNonCreditMoney": {
                            "type": ".squareup.common.Money",
                            "id": 30,
                            "rule": "optional"
                          },
                          "swedishRoundingMoney": {
                            "type": ".squareup.common.Money",
                            "id": 31,
                            "rule": "optional"
                          },
                          "giftCardNetSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 32,
                            "rule": "optional"
                          },
                          "bankAccountSuffix": {
                            "type": "string",
                            "id": 33,
                            "rule": "optional"
                          },
                          "bankName": {
                            "type": "string",
                            "id": 34,
                            "rule": "optional"
                          },
                          "billingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 35,
                            "rule": "optional"
                          },
                          "merchant": {
                            "type": ".squareup.beemo.api.v2.models.Merchant",
                            "id": 36,
                            "rule": "optional"
                          },
                          "depositFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 37,
                            "rule": "optional"
                          },
                          "capitalRepaymentRefundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 38,
                            "rule": "optional"
                          },
                          "taxOnFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 39,
                            "rule": "optional"
                          },
                          "australianGrossSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 40,
                            "rule": "optional"
                          },
                          "billingRefundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 41,
                            "rule": "optional"
                          },
                          "settlementType": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementType",
                            "id": 42,
                            "rule": "optional"
                          },
                          "feeMoneyDetail": {
                            "type": ".squareup.beemo.api.v2.reporting.FeeMoneyDetail",
                            "id": 43,
                            "rule": "optional"
                          },
                          "productSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 44,
                            "rule": "optional"
                          },
                          "cardInfo": {
                            "type": ".squareup.beemo.api.v2.reporting.CardInfo",
                            "id": 45,
                            "rule": "optional"
                          },
                          "payments": {
                            "type": ".squareup.ledger.LedgerEntrySummary.Payments.Payment",
                            "id": 46,
                            "rule": "repeated"
                          },
                          "refundedPayments": {
                            "type": ".squareup.ledger.LedgerEntrySummary.Payments.Payment",
                            "id": 47,
                            "rule": "repeated"
                          },
                          "settledBillEntryTokenGroup": {
                            "type": ".squareup.beemo.api.v2.reporting.SettledBillEntryTokenGroup",
                            "id": 48,
                            "rule": "repeated"
                          },
                          "capitalPromotionMoney": {
                            "type": ".squareup.common.Money",
                            "id": 49,
                            "rule": "optional"
                          },
                          "returnedGrossSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 50,
                            "rule": "optional"
                          },
                          "amountBasedRefundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 51,
                            "rule": "optional"
                          },
                          "returnedProductSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 52,
                            "rule": "optional"
                          },
                          "pushTenderCount": {
                            "type": "int32",
                            "id": 53,
                            "rule": "optional"
                          },
                          "partialPaymentsMoney": {
                            "type": ".squareup.common.Money",
                            "id": 54,
                            "rule": "optional"
                          },
                          "partialPaymentsMoneySentInOtherDeposits": {
                            "type": ".squareup.common.Money",
                            "id": 55,
                            "rule": "optional"
                          },
                          "totalReservesAmountReleased": {
                            "type": ".squareup.common.Money",
                            "id": 56,
                            "rule": "optional"
                          },
                          "totalReservesAmountHeld": {
                            "type": ".squareup.common.Money",
                            "id": 57,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 58,
                            "rule": "optional"
                          },
                          "externalTransferTraceInfo": {
                            "type": ".squareup.deposits.ExternalTransferTraceInfo",
                            "id": 60,
                            "rule": "repeated"
                          },
                          "sfsSavingsMoney": {
                            "type": ".squareup.common.Money",
                            "id": 62,
                            "rule": "optional"
                          },
                          "totalAfterpayPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 63,
                            "rule": "optional"
                          },
                          "totalPaypayPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 64,
                            "rule": "optional"
                          },
                          "capitalCreditCardTransferMoney": {
                            "type": ".squareup.common.Money",
                            "id": 65,
                            "rule": "optional"
                          },
                          "investTransferMoney": {
                            "type": ".squareup.common.Money",
                            "id": 66,
                            "rule": "optional"
                          },
                          "bankingFolderTransferMoney": {
                            "type": ".squareup.common.Money",
                            "id": 67,
                            "rule": "optional"
                          },
                          "localOffersCashBackMoney": {
                            "type": ".squareup.common.Money",
                            "id": 68,
                            "rule": "optional"
                          },
                          "localOffersFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 69,
                            "rule": "optional"
                          },
                          "percentageProcessingTransferMoney": {
                            "type": ".squareup.common.Money",
                            "id": 70,
                            "rule": "optional"
                          },
                          "giftCardPoolTransferMoney": {
                            "type": ".squareup.common.Money",
                            "id": 71,
                            "rule": "optional"
                          },
                          "totalAlipayPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 72,
                            "rule": "optional"
                          },
                          "totalRakutenPayPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 73,
                            "rule": "optional"
                          },
                          "totalAuPayPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 74,
                            "rule": "optional"
                          },
                          "totalDBaraiPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 75,
                            "rule": "optional"
                          },
                          "totalMerpayPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 76,
                            "rule": "optional"
                          },
                          "totalWechatPayPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 77,
                            "rule": "optional"
                          },
                          "totalPercentageProcessingEnrollmentAmount": {
                            "type": ".squareup.common.Money",
                            "id": 78,
                            "rule": "optional"
                          },
                          "totalPercentageProcessingDeactivationAmount": {
                            "type": ".squareup.common.Money",
                            "id": 79,
                            "rule": "optional"
                          },
                          "totalPercentageProcessingRepaymentAmount": {
                            "type": ".squareup.common.Money",
                            "id": 80,
                            "rule": "optional"
                          },
                          "giftCardLoadFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 81,
                            "rule": "optional"
                          },
                          "freeProcessingPreTaxMoney": {
                            "type": ".squareup.common.Money",
                            "id": 82,
                            "rule": "optional"
                          },
                          "lineOfCreditRepaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 83,
                            "rule": "optional"
                          },
                          "bitcoinBuySpentAmount": {
                            "type": ".squareup.common.Money",
                            "id": 84,
                            "rule": "optional"
                          },
                          "bitcoinSellProceedsAmount": {
                            "type": ".squareup.common.Money",
                            "id": 85,
                            "rule": "optional"
                          },
                          "totalBitcoinPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 86,
                            "rule": "optional"
                          },
                          "totalEmployeeTipPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 87,
                            "rule": "optional"
                          },
                          "totalEmployeeTipPaymentRefundMoney": {
                            "type": ".squareup.common.Money",
                            "id": 88,
                            "rule": "optional"
                          },
                          "totalLocalCashPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 89,
                            "rule": "optional"
                          }
                        }
                      },
                      "CardInfo": {
                        "fields": {
                          "panSuffix": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cardBrand": {
                            "type": ".squareup.bills.CardTender.Card.Brand",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cardInstrumentToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "FeeMoneyDetail": {
                        "fields": {
                          "paymentInitialFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "paymentInitialTaxOnFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "paymentAdjustmentFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "paymentAdjustmentFee": {
                            "type": ".squareup.beemo.api.v2.reporting.FeeMoneyDetail.AdjustmentFee",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "monthlyFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "settlementFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "thirdPartyFeeAmountDetail": {
                            "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "firstPartyFeeAmountDetail": {
                            "type": ".squareup.beemo.api.v2.reporting.FeeMoneyDetail.FirstPartyFeeAmountDetail",
                            "id": 7,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "AdjustmentFee": {
                            "fields": {
                              "feePeriodStartAt": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 1,
                                "rule": "optional"
                              },
                              "feeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "taxOnFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "FirstPartyFeeAmountDetail": {
                            "fields": {
                              "feePlanProduct": {
                                "type": ".squareup.feeplans.FeePlanProduct",
                                "id": 1,
                                "rule": "optional"
                              },
                              "feeAmount": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "SettlementReportLite": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "bankAccountToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "settlementMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 4,
                            "rule": "optional"
                          },
                          "success": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "settlementType": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementType",
                            "id": 6,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "settlementFrequency": {
                            "type": ".squareup.ledger.SettlementFrequency",
                            "id": 8,
                            "rule": "optional"
                          },
                          "allowSplitTransfer": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "destinationName": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "accountSuffix": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      },
                      "ListInvoiceMetadataRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ListInvoiceMetadataResponse": {
                        "fields": {
                          "invoiceMetadata": {
                            "type": ".squareup.beemo.api.v2.reporting.ListInvoiceMetadataResponse.InvoiceMetadata",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "InvoiceMetadata": {
                            "fields": {
                              "unitToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "invoiceYear": {
                                "type": "int32",
                                "id": 2,
                                "rule": "optional"
                              },
                              "invoiceMonth": {
                                "type": "int32",
                                "id": 3,
                                "rule": "optional"
                              },
                              "invoiceToken": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "InvoiceSettlementReportRequest": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "interval": {
                            "type": ".squareup.common.time.DateTimeInterval",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "InvoiceSettlementReportResponse": {
                        "fields": {
                          "total": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportResponse.Totals",
                            "id": 1,
                            "rule": "optional"
                          },
                          "adjustmentFees": {
                            "type": ".squareup.beemo.api.v2.reporting.FeeMoneyDetail.AdjustmentFee",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SettlementReportLiteResponse": {
                        "fields": {
                          "settlements": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportLite",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "batchResponse": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportLiteResponse.BatchResponse",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "BatchResponse": {
                            "fields": {
                              "nextBatchToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "SettlementReportWrapper": {
                        "fields": {
                          "settlement": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReport",
                            "id": 1,
                            "rule": "optional"
                          },
                          "settlementByDate": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReport",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SettlementReportRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "includeSettlementEntries": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "settlementTokens": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "useLedger": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          },
                          "includeFailedSettlements": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "batchRequest": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportRequest.BatchRequest",
                            "id": 6,
                            "rule": "optional"
                          },
                          "requestFlags": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportRequest.RequestFlags",
                            "id": 7,
                            "rule": "optional"
                          },
                          "includeZeroDollarSettlements": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeUnsentSquareCashDeposits": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        },
                        "nested": {
                          "BatchRequest": {
                            "fields": {
                              "batchSize": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional",
                                "options": {
                                  "default": 20
                                }
                              },
                              "batchToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "RequestFlags": {
                            "fields": {
                              "alwaysReturnAllLedgerEntries": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional",
                                "options": {
                                  "default": false
                                }
                              }
                            }
                          }
                        }
                      },
                      "SettlementReportResponse": {
                        "fields": {
                          "settlements": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReport",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "settlementReports": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "settlementTotals": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportResponse.Totals",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Totals": {
                            "fields": {
                              "totalCreditMoney": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "totalFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "taxOnFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "totalFeeAssessedMoney": {
                                "type": ".squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              },
                              "totalFreeProcessingMoney": {
                                "type": ".squareup.common.Money",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "PendingSettlementResponse": {
                        "fields": {
                          "nextSettlementMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "settlementReports": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "PendingSettlementRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "PendingSettlementsRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "excludeSettlementsByDate": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          },
                          "excludeTransactionAggregates": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "includeUnsentSquareCashDeposits": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "PendingSettlementsResponse": {
                        "fields": {
                          "activeSalesReport": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pendingSettlementReport": {
                            "type": ".squareup.beemo.api.v2.reporting.SettlementReportWrapper",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SettledBillEntryTokenGroup": {
                        "fields": {
                          "billToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "paymentToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "refundUuid": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SplitDeposit": {
                        "fields": {
                          "settlementToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "money": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SplitDepositRequest": {
                        "fields": {
                          "requestParams": {
                            "type": ".squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "settlementToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "SplitDepositResponse": {
                        "fields": {
                          "previousSplitDeposit": {
                            "type": ".squareup.beemo.api.v2.reporting.SplitDeposit",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "nextSplitDeposit": {
                            "type": ".squareup.beemo.api.v2.reporting.SplitDeposit",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "previousDay": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "nextDay": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementEntry && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReport && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.CardInfo && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.FeeMoneyDetail && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.FeeMoneyDetail?.nested?.AdjustmentFee && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.FeeMoneyDetail?.nested?.FirstPartyFeeAmountDetail && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportLite && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ListInvoiceMetadataRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ListInvoiceMetadataResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.ListInvoiceMetadataResponse?.nested?.InvoiceMetadata && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.InvoiceSettlementReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.InvoiceSettlementReportResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportLiteResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportLiteResponse?.nested?.BatchResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportWrapper && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportRequest?.nested?.BatchRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportRequest?.nested?.RequestFlags && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettlementReportResponse?.nested?.Totals && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.PendingSettlementResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.PendingSettlementRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.PendingSettlementsRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.PendingSettlementsResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SettledBillEntryTokenGroup && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SplitDeposit && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SplitDepositRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SplitDepositResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SettlementType @ squareup/beemo/v2/reporting/settlements.proto at 20:1
 */
export const SettlementType = $root.lookupEnum('squareup.beemo.api.v2.reporting.SettlementType').values;
/**
 * This is a distilled LedgerEntry.
 * We don't re-use the existing LedgerEntry proto to prevent breaking api changes
 * as well as limiting the amount of exposed data to clients.
 *
 * SOURCE SettlementEntry @ squareup/beemo/v2/reporting/settlements.proto at 71:1
 */
export const SettlementEntry = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementEntry');
fixType(SettlementEntry);
Builder.createAndAttachToType(SettlementEntry);
/**
 * This is a distilled BankSettlementEntry.
 *
 * SOURCE SettlementReport @ squareup/beemo/v2/reporting/settlements.proto at 111:1
 */
export const SettlementReport = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReport');
fixType(SettlementReport);
Builder.createAndAttachToType(SettlementReport);
/**
 * Details associated with a debit card.
 *
 * SOURCE CardInfo @ squareup/beemo/v2/reporting/settlements.proto at 404:1
 */
export const CardInfo = $root.lookupType('squareup.beemo.api.v2.reporting.CardInfo');
fixType(CardInfo);
Builder.createAndAttachToType(CardInfo);
/**
 * A detail of fees in a report.
 *
 * This is a breakdown of total_fee_money of SettlementReport:
 *
 * total_fee_money = payment_initial_fee_money
 *                 + payment_adjustment_fee_money
 *                 + monthly_fee_money
 * + settlement_fee_money
 *
 * SOURCE FeeMoneyDetail @ squareup/beemo/v2/reporting/settlements.proto at 425:1
 */
export const FeeMoneyDetail = $root.lookupType('squareup.beemo.api.v2.reporting.FeeMoneyDetail');
fixType(FeeMoneyDetail);
Builder.createAndAttachToType(FeeMoneyDetail);
/**
 * Adjustments grouped by fee_period_start_at.
 *
 * SOURCE AdjustmentFee @ squareup/beemo/v2/reporting/settlements.proto at 450:3
 */
FeeMoneyDetail.AdjustmentFee = $root.lookupType('squareup.beemo.api.v2.reporting.FeeMoneyDetail.AdjustmentFee');
fixType(FeeMoneyDetail.AdjustmentFee);
Builder.createAndAttachToType(FeeMoneyDetail.AdjustmentFee);
/**
 * Breakdown of Square's fees by FeePlanProduct
 * payment_initial_fee_money = sum(first_party_fee_amount_detail.fee_amount)
 *                           + sum(third_party_fee_amount_details.amount)
 *
 * SOURCE FirstPartyFeeAmountDetail @ squareup/beemo/v2/reporting/settlements.proto at 502:3
 */
FeeMoneyDetail.FirstPartyFeeAmountDetail = $root.lookupType('squareup.beemo.api.v2.reporting.FeeMoneyDetail.FirstPartyFeeAmountDetail');
fixType(FeeMoneyDetail.FirstPartyFeeAmountDetail);
Builder.createAndAttachToType(FeeMoneyDetail.FirstPartyFeeAmountDetail);
/**
 * A simplified, more efficient settlement report.
 *
 * SOURCE SettlementReportLite @ squareup/beemo/v2/reporting/settlements.proto at 514:1
 */
export const SettlementReportLite = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportLite');
fixType(SettlementReportLite);
Builder.createAndAttachToType(SettlementReportLite);
/**
 * SOURCE ListInvoiceMetadataRequest @ squareup/beemo/v2/reporting/settlements.proto at 753:1
 */
export const ListInvoiceMetadataRequest = $root.lookupType('squareup.beemo.api.v2.reporting.ListInvoiceMetadataRequest');
fixType(ListInvoiceMetadataRequest);
Builder.createAndAttachToType(ListInvoiceMetadataRequest);
/**
 * SOURCE ListInvoiceMetadataResponse @ squareup/beemo/v2/reporting/settlements.proto at 757:1
 */
export const ListInvoiceMetadataResponse = $root.lookupType('squareup.beemo.api.v2.reporting.ListInvoiceMetadataResponse');
fixType(ListInvoiceMetadataResponse);
Builder.createAndAttachToType(ListInvoiceMetadataResponse);
/**
 * SOURCE InvoiceMetadata @ squareup/beemo/v2/reporting/settlements.proto at 758:3
 */
ListInvoiceMetadataResponse.InvoiceMetadata = $root.lookupType('squareup.beemo.api.v2.reporting.ListInvoiceMetadataResponse.InvoiceMetadata');
fixType(ListInvoiceMetadataResponse.InvoiceMetadata);
Builder.createAndAttachToType(ListInvoiceMetadataResponse.InvoiceMetadata);
/**
 * Internal beemo endpoint to generate total credit + total fee (including free processing)
 * for the given time interval.
 * Instead of reading deposit entries => related ledger entries it will directly query
 * ledger entries within the range.
 * See OMG-3276 & the linked ONCALL ticket.
 *
 * SOURCE InvoiceSettlementReportRequest @ squareup/beemo/v2/reporting/settlements.proto at 776:1
 */
export const InvoiceSettlementReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.InvoiceSettlementReportRequest');
fixType(InvoiceSettlementReportRequest);
Builder.createAndAttachToType(InvoiceSettlementReportRequest);
/**
 * Reuse the settlement report totals. This should use the same calculations as SettlementReport.
 *
 * SOURCE InvoiceSettlementReportResponse @ squareup/beemo/v2/reporting/settlements.proto at 786:1
 */
export const InvoiceSettlementReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.InvoiceSettlementReportResponse');
fixType(InvoiceSettlementReportResponse);
Builder.createAndAttachToType(InvoiceSettlementReportResponse);
/**
 * SOURCE SettlementReportLiteResponse @ squareup/beemo/v2/reporting/settlements.proto at 791:1
 */
export const SettlementReportLiteResponse = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportLiteResponse');
fixType(SettlementReportLiteResponse);
Builder.createAndAttachToType(SettlementReportLiteResponse);
/**
 * SOURCE BatchResponse @ squareup/beemo/v2/reporting/settlements.proto at 794:3
 */
SettlementReportLiteResponse.BatchResponse = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportLiteResponse.BatchResponse');
fixType(SettlementReportLiteResponse.BatchResponse);
Builder.createAndAttachToType(SettlementReportLiteResponse.BatchResponse);
/**
 * SOURCE SettlementReportWrapper @ squareup/beemo/v2/reporting/settlements.proto at 806:1
 */
export const SettlementReportWrapper = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportWrapper');
fixType(SettlementReportWrapper);
Builder.createAndAttachToType(SettlementReportWrapper);
/**
 * SOURCE SettlementReportRequest @ squareup/beemo/v2/reporting/settlements.proto at 812:1
 */
export const SettlementReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportRequest');
fixType(SettlementReportRequest);
Builder.createAndAttachToType(SettlementReportRequest);
/**
 * SOURCE BatchRequest @ squareup/beemo/v2/reporting/settlements.proto at 834:3
 */
SettlementReportRequest.BatchRequest = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportRequest.BatchRequest');
fixType(SettlementReportRequest.BatchRequest);
Builder.createAndAttachToType(SettlementReportRequest.BatchRequest);
/**
 * A list of flags which can be used to control specific behaviors.
 * e.g. return all ledger entries regardless of existence of transaction in beemo.
 *
 * SOURCE RequestFlags @ squareup/beemo/v2/reporting/settlements.proto at 855:3
 */
SettlementReportRequest.RequestFlags = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportRequest.RequestFlags');
fixType(SettlementReportRequest.RequestFlags);
Builder.createAndAttachToType(SettlementReportRequest.RequestFlags);
/**
 * SOURCE SettlementReportResponse @ squareup/beemo/v2/reporting/settlements.proto at 891:1
 */
export const SettlementReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportResponse');
fixType(SettlementReportResponse);
Builder.createAndAttachToType(SettlementReportResponse);
/**
 * SOURCE Totals @ squareup/beemo/v2/reporting/settlements.proto at 896:3
 */
SettlementReportResponse.Totals = $root.lookupType('squareup.beemo.api.v2.reporting.SettlementReportResponse.Totals');
fixType(SettlementReportResponse.Totals);
Builder.createAndAttachToType(SettlementReportResponse.Totals);
/**
 * SOURCE PendingSettlementResponse @ squareup/beemo/v2/reporting/settlements.proto at 911:1
 */
export const PendingSettlementResponse = $root.lookupType('squareup.beemo.api.v2.reporting.PendingSettlementResponse');
fixType(PendingSettlementResponse);
Builder.createAndAttachToType(PendingSettlementResponse);
/**
 * SOURCE PendingSettlementRequest @ squareup/beemo/v2/reporting/settlements.proto at 917:1
 */
export const PendingSettlementRequest = $root.lookupType('squareup.beemo.api.v2.reporting.PendingSettlementRequest');
fixType(PendingSettlementRequest);
Builder.createAndAttachToType(PendingSettlementRequest);
/**
 * SOURCE PendingSettlementsRequest @ squareup/beemo/v2/reporting/settlements.proto at 921:1
 */
export const PendingSettlementsRequest = $root.lookupType('squareup.beemo.api.v2.reporting.PendingSettlementsRequest');
fixType(PendingSettlementsRequest);
Builder.createAndAttachToType(PendingSettlementsRequest);
/**
 * SOURCE PendingSettlementsResponse @ squareup/beemo/v2/reporting/settlements.proto at 938:1
 */
export const PendingSettlementsResponse = $root.lookupType('squareup.beemo.api.v2.reporting.PendingSettlementsResponse');
fixType(PendingSettlementsResponse);
Builder.createAndAttachToType(PendingSettlementsResponse);
/**
 * SOURCE SettledBillEntryTokenGroup @ squareup/beemo/v2/reporting/settlements.proto at 949:1
 */
export const SettledBillEntryTokenGroup = $root.lookupType('squareup.beemo.api.v2.reporting.SettledBillEntryTokenGroup');
fixType(SettledBillEntryTokenGroup);
Builder.createAndAttachToType(SettledBillEntryTokenGroup);
/**
 * SOURCE SplitDeposit @ squareup/beemo/v2/reporting/settlements.proto at 959:1
 */
export const SplitDeposit = $root.lookupType('squareup.beemo.api.v2.reporting.SplitDeposit');
fixType(SplitDeposit);
Builder.createAndAttachToType(SplitDeposit);
/**
 * SOURCE SplitDepositRequest @ squareup/beemo/v2/reporting/settlements.proto at 967:1
 */
export const SplitDepositRequest = $root.lookupType('squareup.beemo.api.v2.reporting.SplitDepositRequest');
fixType(SplitDepositRequest);
Builder.createAndAttachToType(SplitDepositRequest);
/**
 * SOURCE SplitDepositResponse @ squareup/beemo/v2/reporting/settlements.proto at 975:1
 */
export const SplitDepositResponse = $root.lookupType('squareup.beemo.api.v2.reporting.SplitDepositResponse');
fixType(SplitDepositResponse);
Builder.createAndAttachToType(SplitDepositResponse);